// extracted by mini-css-extract-plugin
export default {"about":"About_about__ZBiKp","container":"About_container__D9yA3","link":"About_link__pAULM","descr":"About_descr__UY5js"};